//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    headline: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: null,
    },
    profile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: true,
    }
  },
  computed: {
    conrolId() {
      return this.$slugify(this.headline + '-panel', {
        lower: true,
        trim: true,
      })
    },
  },
  mounted() {
    this.isExpanded = !this.profile
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded
    },
  },
}
